import PropTypes from "prop-types"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import { AcademicLevel, Campaigns, Campus, Consentement, ConsentementMultiple, MentionsLegales, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber } from "components/fields"
import { useForms, useSalesforce, useSubmission, useUrlReturn } from "hooks"
import { campaigns, consent, defaultValues, getCampus } from "services"
import { useEffect, useState } from "react"
import Cursus from "../components/Cursus"
import Programme from "../components/Programme"

const Form = ({ type = 'Conférence' }) => {
  const { recordTypeId, salesforce, setError, setOpenSnackbar } = useForms()
  const { url } = useUrlReturn('EART-CONF')
  const { submission } = useSubmission()
  // Styles
  // Form
  const methods = useForm({
    defaultValues: {
      ...campaigns,
      ...consent,
      lead: {
        ...defaultValues,
      },
    },
    resolver: yupResolver(schema)
  })
  const { control, setValue, watch } = methods
  // State
  const [optionsAcademicLevels, setOptionsAcademicLevels] = useState([])
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = {
      ...data.lead,
    }
    const campaignId = data.campaignId
    const defaultDataLead = {
      Division__c: 'e-artsup',
      IONISSchool__c: 'e-artsup',
      LastForm__c: data.status === 'RegisteredOnline' ? 'Webinar' : 'Conference',
      LeadSource: data.status === 'RegisteredOnline' ? 'Webinar' : 'Conférence',
      RecordTypeId: recordTypeId
    }
    const finalLead = {...lead, ...defaultDataLead}
    try {
      // const leadCreated = await salesforce.createLead(finalLead)
      if (campaignId !== 'unavailable') {
        // const campaignMember = {
        //   CampaignId: campaignId,
        //   LeadId: leadCreated.Id,
        //   Status: data.status
        // }
        // await salesforce.createCampaignMember(campaignMember)
        await submission({
          formId: 'CONFERENCE',
          lead: finalLead,
          campaignId: campaignId,
          campaignStatus: data.status,
          utmCookieName: '_ionis_user_data' // optionnel
        })
        document.location.href=`${url}?ville=${campus}&campaignId=${campaignId}`
      } else {
        let description = ''

        if (data.availabilities.type === 'Être rappelé(e) sur Skype') {
          description = 'ID Skype : ' + data.availabilities.skypeId + '\n\n'
        }
        description += data.availabilities.dates.join(', ')

        const subject = data.availabilities.type
        await submission({
          formId: 'CONTACT',
          lead: finalLead,
          subject: subject,
          description: description,
          utmCookieName: '_ionis_user_data' // optionnel
        })
        // const task = {
        //   ActivityDate: new Date(),
        //   Description: description,
        //   OwnerId: leadCreated.OwnerId,
        //   Subject: subject,
        //   WhoId: leadCreated.Id
        // }

        // await salesforce.createTask(task)
        document.location.href=`${url}?ville=${campus}`
      }
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  // Watch
  const watchCampaignId = watch('campaignId')
  const campus = watch('lead.Campus__c')
  const campaignNational = watch('campaignNational')
  // useEffect
  useSalesforce('BusinessSchoolLead')
  useEffect(() => {
    if (type === 'Webinar') {
      setValue('campaignNational', true)
    }
  }, [type, setValue])
  // Functions
  const handleAcademicLevels = (academics) => {
    setOptionsAcademicLevels(academics)
  }

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        {type === 'Conférence' && (
          <>
            <Campus label={!campaignNational ? 'Ville choisie pour participer à la conférence' : `Campus d'intérêt`} options={getCampus('e-artsup')} />
            <Campaigns contact={false} division="e-artsup" school="e-artsup" setAcademicLevels={handleAcademicLevels} text="à la conférence" type={type} />
          </>
        )}
        {type === 'Webinar' && (
          <>
            <Campaigns contact={false} division="e-artsup" school="e-artsup" setAcademicLevels={handleAcademicLevels} text="au live" type={type} />
            <Campus label={!campaignNational ? 'Ville choisie pour participer à la conférence' : `Campus d'intérêt`} options={getCampus('e-artsup')} />
          </>
        )}
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone mobile" required />
        </Grid>
        <AcademicLevel school="e-artsup" section={false} specialites={false} />
        <ConsentementMultiple callOptIn={watchCampaignId === 'unavailable'} />
        <RequiredFields />
        <Submit onSubmit={onSubmit} />
        <MentionsLegales form="Conference" school="e-artsup" />
      </Grid>
    </FormProvider>
  )
}

Form.propTypes = {
  type: PropTypes.string
}

export default Form
